import SITE_SETTINGS from 'src/constants/whiteLabel';
import { getDocumentId } from 'src/utils/mongo/getDocumentId';
import { createActionHandler } from 'src/modules/assistant/actions/createActionHandler';
import { TSendEmailDraft } from 'src/modules/assistant/actions/types';
import { hasRequiredDocuments } from 'src/modules/assistant/helpers/hasRequiredDocuments';

const DOCUMENTATION_TEMPLATE_PREFIX = 'documentation_';

export const sendEmail = createActionHandler<TSendEmailDraft>({
    fields: [
        ['email', 'Assistant.ActionFieldEmail'],
        ['subject', 'Assistant.ActionFieldSubject'],
        ['message', 'Assistant.ActionFieldMessage', true],
    ],
    acceptsDocuments: true,
    validate: (draft) =>
        Boolean(
            draft.email?.trim() &&
                draft.subject?.trim() &&
                draft.message?.trim()
        ) && hasRequiredDocuments(draft),
    execute: (draft, { lead, leadActions }) =>
        leadActions.sendDocumentationV2({
            email: draft.email,
            subject: draft.subject,
            message: draft.message,
            template: `${DOCUMENTATION_TEMPLATE_PREFIX}${SITE_SETTINGS.client}`,
            attachments: draft.attachments || [],
            documents: [],
            store: getDocumentId(lead.store),
            user: getDocumentId(lead.agent),
            lead: lead._id,
            isAssistantGenerated: true,
        }),
});
